import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import type { PlacesOpen } from '../types';
import { GET_PLACES_OPEN } from '../constants';
import { HEADER_TOTAL_COUNT } from '@/_config/lib/axios/interceptors';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';

type GetPlacesInfosDashboardParams = {
  cityId: string;
  limit?: number;
  page?: number;
};

const getPlacesInfosDashboard = (params: GetPlacesInfosDashboardParams) => {
  const { cityId, page, limit } = params;

  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return apiClient
    .get<PlacesOpen[]>(`estabelecimentos/cities/${cityId}/dashboard/places`, {
      params: {
        limit: newLimit,
        offset,
      },
    })
    .then(response => ({
      data: response.data,
      totalCount: parseInt(response.headers[HEADER_TOTAL_COUNT] || '', 10),
    }))
    .catch(handleResponseThrowError());
};

type GetPlacesOpenResponse = Awaited<
  ReturnType<typeof getPlacesInfosDashboard>
>;

export const useGetPlacesInfosDashboard = (
  params: GetPlacesInfosDashboardParams,
  options: Omit<
    UseQueryOptions<
      GetPlacesOpenResponse,
      unknown,
      GetPlacesOpenResponse,
      (string | GetPlacesInfosDashboardParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACES_OPEN, params],
    queryFn: () => getPlacesInfosDashboard(params),
    ...options,
  });
};
